import { Breadcrumbs } from "../../../AbstractElements";
import { Buttons, DefaultStyle } from "../../../Constant";
import { Col, Container, Row } from "reactstrap";
import LargeButtons from "./LargeButtons";
import SmallButtons from "./SmallButtons";
import ExtraSmallButtons from "./ExtraSmallButtons";
import ActiveButtons from "./ActiveButtons";
import DisabledButtons from "./DisabledButtons";
import CustomStateButtons from "./CustomStateButtons";
import DefaultButtons from "./DefaultButtons";
import OutlineButtons from "./OutlineButtons";
import BoldBorderOutlineButtons from "./BoldBorderOutlineButtons";
import OutlineLargeButtons from "./OutlineLargeButtons";
import OutlineSmallButtons from "./OutlineSmallButtons";
import OutlineExtraSmallButtons from "./OutlineExtraSmallButtons";
import DisabledOutlineButtons from "./DisabledOutlineButtons";
import GradienButtons from "./GradienButtons";

const DefaultStyleContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={DefaultStyle} parent={Buttons} title={DefaultStyle} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <DefaultButtons />
            <LargeButtons />
            <SmallButtons />
            <ExtraSmallButtons />
            <ActiveButtons />
            <DisabledButtons />
            <CustomStateButtons />
            <OutlineButtons/>
            <BoldBorderOutlineButtons/>
            <OutlineLargeButtons/>
            <OutlineSmallButtons/>
            <OutlineExtraSmallButtons/>
            <DisabledOutlineButtons/>
            <GradienButtons/>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DefaultStyleContainer;
